module.exports = __webpack_public_path__ + "img/businessLicenseUrl_shili.8cb05096.png";